import React from "react";
import { useNavigate } from "react-router-dom";
export default function SubCategoriaEncontrada({ nombre, totalCursos, id }) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`?f=cnc&curso_id=${id}`, {replace: true}); 
  };
  return (
    <>
      <div
        data-figma-id="5381:19933"
        className="menu-organizacion-ejemplo"
        onClick={handleNavigate}
      >
        <p
          data-figma-id="5381:19935"
          className="menu-organizacion-ejemplo-texto truncate-1-line"
        >
          {nombre}
        </p>
      </div>
    </>
  );
}
